import React, { useEffect, useState } from "react";

import { Flex, Box, P, Button } from "ui-components";
import Spinner, { styles } from "components/Spinner";
import { buttonThemes } from "ui-components/theme";
import { paths } from "utils/constants";
import { gotoUrl, handleRedirect } from "utils/helpers";

import FormattedMessage from "components/FormattedMessage";

const _imageStyle = {
  width: 325,
  mt: 80
};

const _messageStyle = {
  mt: 120,
  textAlign: "center!important",
  fontWeight: "bold"
};

const defaultRedirects = [
  {
    enabled: false,
    from: "/circles3/",
    preserveQuery: true,
    to: "/circleslarpu/sa_delivery?reset=true"
  },
  {
    enabled: false,
    from: "/manage/order",
    preserveQuery: true,
    to: "https://shop.circles.life/manage/order?reset=true"
  },
  {
    enabled: true,
    from: "/activate/sa_delivery",
    preserveQuery: true,
    to: "/circles1/sa_delivery?reset=true"
  },
  {
    enabled: true,
    from: "/activate/sim",
    preserveQuery: true,
    to: "/self_activation/sim?reset=true"
  },
  {
    enabled: true,
    from: "/activate/verify",
    preserveQuery: false,
    to: "/self_activation/sim?reset=true"
  },
  {
    enabled: true,
    from: "/esim/transfer_number",
    preserveQuery: true,
    to: "/e-sim/keep-number?reset=true"
  },
  {
    enabled: true,
    from: "/esim/new_number",
    preserveQuery: true,
    to: "/e-sim/new-number?reset=true"
  }
];

const backgroundColor = `${buttonThemes?.blue?.color} !important`;
const hoverColor = `${buttonThemes?.blue?.hoverColor} !important`;
const _buttonStyle = {
  background: backgroundColor,
  color: "#FFF",
  borderColor: backgroundColor,
  minWidth: "10rem !important",
  py: 12,
  borderRadius: 23,
  ":hover": {
    background: hoverColor,
    borderColor: hoverColor
  }
};

const PageError = ({ errorPagesConfig }) => {
  const [loading, setLoading] = useState(true);
  const config = errorPagesConfig?.["404"] || {};
  const errorImage = config.image || "/assets/images/404.png";
  const imageStyle = { ...(config.imageStyle || {}), ..._imageStyle };
  const imageAlt = config.imageAlt || "";
  const message = config.message || "error_message_404";
  const messageStyle = { ...(config.messageStyle || {}), ..._messageStyle };
  const buttonText = config.buttonText;
  const buttonStyle = { ...(config.buttonStyle || {}), ..._buttonStyle };
  const redirectUrl = config.configUrl || paths.MANAGE_ORDER;

  useEffect(() => {
    handleRedirect(defaultRedirects);
  }, []);

  const handleRedirectOnClick = () => {
    gotoUrl(redirectUrl, true, null, true);
  };

  setTimeout(() => {
    setLoading(false);
  }, 3000);

  return loading ? (
    <Spinner size={200} sx={styles.fullPage} />
  ) : (
    <Flex alignItems="center" flexDirection="column">
      <Box sx={imageStyle}>
        <img alt={imageAlt} src={errorImage} width="100%" height="auto" />
      </Box>
      <P sx={messageStyle}>
        <FormattedMessage html id={message} />
      </P>
      <Box sx={{ mt: 90 }}>
        <Button sx={buttonStyle} onClick={handleRedirectOnClick}>
          {buttonText || <FormattedMessage id="go_back" />}
        </Button>
      </Box>
    </Flex>
  );
};

export default PageError;
